import { render, staticRenderFns } from "./DemosPage.vue?vue&type=template&id=46506eda&scoped=true"
import script from "./DemosPage.vue?vue&type=script&lang=js"
export * from "./DemosPage.vue?vue&type=script&lang=js"
import style0 from "./DemosPage.vue?vue&type=style&index=0&id=46506eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46506eda",
  null
  
)

export default component.exports